import React from "react";
import { useEffect, useState } from "react";

export interface ControllableOptions<T> {
  value?: T;
  defaultValue?: T;
  onChange?: (value: T) => void;
}

function useControllable<T>({
  value,
  defaultValue,
  onChange,
}: ControllableOptions<T>): [T, (next: T) => void] {
  const [internal, setInternal] = useState<T>(
    value !== undefined ? value : (defaultValue as T),
  );

  useEffect(() => {
    if (value !== undefined) {
      setInternal(value);
    }
  }, [value]);

  const set = (next: T) => {
    setInternal(next);
    onChange?.(next);
  };

  return [internal, set];
}

export default useControllable;
